// removed by extract-text-webpack-plugin
module.exports = {"tds-cats-tbl":"tds-cats-tbl___3cSSW","card":"card___zvLtr shadow-broad___37axf","cnfg-cats-icn":"cnfg-cats-icn___a5Zak"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesCategoriesTable/TargetDateSeriesCategoriesTable.css
// module id = 925
// module chunks = 0